(function () {

    'use strict';

    angular.module('FotocApp')

        .component('editor', {

            templateUrl: (USE_TEMPLATE_CACHE ? '' : window.BASE_PATH + '../../src/') + 'editor/editor.component.html',
            bindings: {},
            controller: ['$scope', 'CONSTANTS', '$editorService', '$canvasService', '$timeout', '$http', '$lang', '$window', '$tutorialService', function ($scope, CONSTANTS, $editorService, $canvasService, $timeout, $http, $lang, $window, $tutorialService) {

                var self = this;
                var isLoadingFavs = false;
                this.objectKeys = Object.keys;
                this.$canvasService = $canvasService;
                this.$editorService = $editorService;
                $scope.$lang = $lang;
                this.sharing = false;
                var frameHashShare = '';

                this.firstClientX;
                this.firstClientY;
                this.clientX;
                this.clientY;

                this.$onInit = function () {

                    // Inciamos la aplicacion
                    $editorService.initConfig($window.TYPE_EDITOR);
                    bootstrapApp();

                    $scope.$watch("$ctrl.$editorService.data.layout_size", function () {
                        $editorService.setObjectPrice();
                    });

                    $scope.$watch("$ctrl.$editorService.data.images", function () {
                        $editorService.setObjectPrice();
                    });

                    jqA(document).on('mousedown', function (e) {
                        $canvasService._preventSelection(false);
                        $scope.$apply();
                    });

                    jqA(document).on('touchstart', function (e) {
                        $editorService.hideTools();
                        $canvasService._preventSelection(false)
                        $scope.$apply();
                    });

                    jqA(document).on('mousedown', '#tools', function (e) {
                        e.stopPropagation();
                        return false;
                    });

                    jqA(document).on('touchstart', '#tools', function (e) {
                        e.stopPropagation();
                        return false;
                    });

                    jqA(document).on('mousedown', '#canvas-editor', function (e) {
                        e.stopPropagation();
                        return false;
                    });

                    jqA(document).on('touchstart', '#canvas-editor', function (e) {
                        if ($editorService.ui.toolOpen === 'transform') {
                            e.stopPropagation();
                            return false;
                        }
                    });

                    $window.addEventListener("resize", function () {
                        var w = Math.max(document.documentElement.clientWidth, $window.innerWidth || 0);
                        if (w > 640) {
                            if ($editorService.ui.toolOpen === false) {
                                $editorService.ui.toolOpen = 'images';
                            }

                        }
                    });

                    var mc = new Hammer.Manager(document.getElementById('canvas-editor'), {
                        touchAction: 'auto'
                    });
                    var pinch = new Hammer.Pinch();
                    var rotate = new Hammer.Rotate();
                    pinch.recognizeWith(rotate);
                    mc.add([pinch, rotate]);
                    mc.on("pinch rotate", function (ev) {
                        ev.srcEvent.preventDefault();
                        if ($editorService.ui.toolOpen !== 'transform') {
                            $editorService.ui.toolOpen = 'transform';
                            $scope.$apply();
                        }

                    });

                    document.getElementById('canvas-editor').addEventListener('touchstart', touchStart);
                    document.getElementById('canvas-editor').addEventListener('touchmove', preventTouch, { passive: false });
                    document.getElementById('canvas-editor').addEventListener('touchstart', function (e) {
                        e.stopPropagation();
                    });
                };

                function touchStart(e) {
                    this.firstClientX = e.touches[0].clientX;
                    this.firstClientY = e.touches[0].clientY;
                }

                function preventTouch(e) {
                    var minValue = 5; // threshold
                    this.clientX = e.touches[0].clientX - this.firstClientX;
                    this.clientY = e.touches[0].clientY - this.firstClientY;

                    // Vertical scrolling does not work when you start swiping horizontally.
                    if (Math.abs(this.clientX) > minValue) {
                        e.preventDefault();
                        e.returnValue = false;
                        return false;
                    }
                }

                this.mousedown = function ($event) {
                    $editorService.ui.toolOpen = false;
                };

                this.onChangeSize = function () {
                    $editorService.ui.sizeManualSelected = $editorService.data.layout_size;
                    $tutorialService.show('size')
                }

                function bootstrapApp() {
                    $canvasService.init();
                    $editorService.initLayout();

                    jqA('#ColorPickerTool').materialColorPicker({
                        title: $lang['TXT_COLOR_WALL_TITLE'],
                        offset: false,
                        format: "hex",
                        onSelect: function (e) {
                            if (e.currentcolor) {
                                $editorService.ui.bgColor = e.currentcolor.color;
                                $scope.$apply();
                            }
                        }, buttonbar: {
                            done: {
                                title: $lang['TXT_COLOR_WALL_OK'],
                                action: function () {
                                    jqA("#ColorPickerTool").materialColorPicker('close');
                                }
                            }
                        }, onInit: function (e) {

                        }
                    });

                    if ($editorService.ui.launchTutorialOnInit) {
                        $timeout(function () {
                            $tutorialService.show('init')
                        }, 2000);
                    }
                }

                this.share = function () {
                    $canvasService.isLoading = true;
                    $http({
                        method: 'POST',
                        url: CONSTANTS.WEB_PATH + 'share/save.php?editorType=' + $editorService.ui.type,
                        data: $canvasService.getShareSnapshoot(),
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }

                    }).then(function (response) {
                        frameHashShare = response.data.f
                        $canvasService.isLoading = false;
                        self.sharing = true

                    }, function (response) {
                        $canvasService.isLoading = false;
                        alert('ocurruio un error 1002')
                    });
                }

                this.shareTo = function ($network) {
                    var endcolde_link = encodeURIComponent($window.WEB_PATH + 'share/?f=' + frameHashShare);
                    switch ($network) {
                        case 'wa':
                            $window.open('whatsapp://send?text=' + encodeURIComponent($lang['TXT_SHARE_TEXT']) + $window.location.hostname + ' ' + endcolde_link);
                            break;
                        case 'fb':
                            $window.open('https://www.facebook.com/sharer/sharer.php?u=' + endcolde_link, 'Compartir en Facebook', 'toolbar=0,status=0,width=528,height=436');
                            break;
                        case 'tw':
                            $window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent($lang['TXT_SHARE_TEXT']) + ' ' + endcolde_link, 'Compartir en Twitter', 'toolbar=0,status=0,width=570,height=436');
                            break;
                    }
                }

                this.setFav = function ($event) {
                    $event.stopPropagation();

                    $editorService.ui.toolOpen = 'favs';
                    if ($editorService.ui.enabledSaveFavs) {
                        $editorService.ui.enabledSaveFavs = false;
                        $editorService.ui.favs.push({});

                        setTimeout(function () {
                            var element = document.getElementById('favs-wrapper');
                            element.scrollLeft = element.scrollWidth;
                        }, 100)

                        $timeout(function () {
                            resizedataDataCanvas($canvasService.getSnapshot(), 200, 200)
                                .then(function (dataURI) {
                                    $editorService.ui.favs[$editorService.ui.favs.length - 1] = {
                                        data: angular.copy($editorService.data),
                                        preview: dataURI
                                    };
                                    $window.localStorage.setItem('editor.service.favs__' + $editorService.ui.type, JSON.stringify($editorService.ui.favs))
                                    $scope.$apply();
                                    $editorService.ui.enabledSaveFavs = true;
                                })
                        }, 1000);
                    }
                }

                this.tranlsateMesureGroup = function (x) {
                    return window.tranlsateMesureGroup(x);
                }
            }]
        })
})();